import React from 'react';
import './index.scss';
import clsx from 'clsx';

import PcPopUp from 'components/molecules/PcPopUp';
import RequiredOrOptionalIcon from '../../atoms/Icon/RequiredOrOptionalIcon';

const PcInputItem = ({
    title,
    subTitle,
    // list = [],
    children,
    invisible,
    label,
    questionMark,
    popUpTitle,
    popUpDetail,
    // type
}) => {
    const DispTitle = () => {
        return Array.isArray(title)
            ? title.map(line => (
                <span key={line} className="">
                    {line}
                    <br />
                </span>
            ))
            : <>{title}</>;
    };

    const DispSubTitle = () => {
        return(
            <div className='subTitle'>{subTitle}</div>
        );
    };
    return (
        !invisible&&
        <div className="PcInputItem">
            <div className="PIA-title">
                <DispTitle />
                {<RequiredOrOptionalIcon label={label} />}
                <span 
                    className={clsx('RequiredOrOptionalIcon',
                        { qShow: questionMark === false })}>
                    <PcPopUp title={popUpTitle} children={popUpDetail}/>
                </span>
                <DispSubTitle />
            </div>
            <span className="PIA-item">
                {/* <DispChild /> */}
                {children}
            </span>
        </div>
    );
};

export default PcInputItem;